export default __webpack_public_path__ + "369ecf4e907e749a0406ee184f806bb1.png";